import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackScreenView } from "../../Utils/analytics";

function resolveScreenName(pathname: string): string {
  const routes: Array<[RegExp, string]> = [
    [/^\/$/, "home"],
    [/^\/login$/i, "login"],
    [/^\/forgotpassword$/i, "forgot_password"],
    [/^\/resetpassword\/[^/]+$/i, "reset_password"],
    [/^\/memberapplication\/apply$/i, "member_application_apply"],
    [/^\/memberapplication\/newapplicant\/[^/]+$/i, "member_application_new_applicant"],
    [/^\/memberapplication\/thankyou$/i, "member_application_thank_you"],
    [/^\/member\/[^/]+\/[^/]+$/i, "public_member_profile"],
    [/^\/user\/[^/]+\/[^/]+$/i, "public_user_profile"],
    [/^\/submitform\/thank-you$/i, "form_thank_you"],
    [/^\/submitform\/[^/]+$/i, "public_form_submit"],
    [/^\/forms\/thank-you$/i, "form_thank_you"],
    [/^\/forms\/fill\/[^/]+$/i, "form_fill"],
    [/^\/forms\/[^/]+\/responses$/i, "form_responses"],
    [/^\/events\/[^/]+\/attending$/i, "public_event_registered_companies"],
    [/^\/events\/[^/]+\/participants$/i, "internal_event_participants"],
    [/^\/events\/[^/]+\/sponsors$/i, "event_sponsors"],
    [/^\/events\/[^/]+\/schedule$/i, "conference_schedule"],
    [/^\/schedule$/i, "my_schedule"],
    [/^\/meetings\/accept\/[^/]+$/i, "meeting_accept_public"],
    [/^\/meetings\/invite\/[^/]+$/i, "meeting_invite"],
    [/^\/members$/i, "members_list"],
    [/^\/members\/tags$/i, "members_tags"],
    [/^\/members\/directory$/i, "members_directory"],
    [/^\/members\/resources$/i, "members_resources"],
    [/^\/members\/fallconvention$/i, "members_fall_convention"],
    [/^\/members\/springmeeting$/i, "members_spring_meeting"],
    [/^\/members\/industryshowcase$/i, "members_industry_showcase"],
    [/^\/members\/awards\/vote$/i, "members_awards_vote"],
    [/^\/admin\/awards$/i, "admin_awards_voting"],
    [/^\/industryshowcase$/i, "public_industry_showcase"],
    [/^\/member\/files$/i, "member_files"],
    [/^\/member\/invoices$/i, "member_invoices"],
    [/^\/member\/my-page$/i, "member_my_page"],
    [/^\/member\/[^/]+$/i, "member_profile"],
    [/^\/edit\/member\/[^/]+$/i, "member_edit_profile"],
    [/^\/users$/i, "users_list"],
    [/^\/users\/fema$/i, "users_fema_info"],
    [/^\/user\/[^/]+$/i, "user_profile"],
    [/^\/edit\/user\/[^/]+$/i, "user_edit_profile"],
    [/^\/newsletters$/i, "newsletters_admin_list"],
    [/^\/newsletters\/new$/i, "newsletter_new"],
    [/^\/newsletters\/edit\/[^/]*$/i, "newsletter_edit"],
    [/^\/forms\/manage$/i, "forms_manage"],
    [/^\/forms\/manage\/[^/]+$/i, "form_builder_edit"],
    [/^\/forms\/new$/i, "form_builder_new"],
    [/^\/forms\/admin\/submissions$/i, "forms_admin_submissions"],
    [/^\/page\/[^/]+$/i, "site_page"],
    [/^\/admin\/pages$/i, "admin_pages"],
    [/^\/admin\/files$/i, "admin_files"],
    [/^\/admin\/ads$/i, "admin_ads"],
    [/^\/admin\/events$/i, "admin_events"],
    [/^\/admin\/forms$/i, "admin_forms"],
    [/^\/admin\/newsletters$/i, "admin_newsletters"],
    [/^\/admin\/emails$/i, "admin_emails_sent"],
    [/^\/admin\/inactive-members$/i, "admin_inactive_members"],
    [/^\/admin\/sponsors$/i, "admin_sponsors"],
    [/^\/partner-opportunities$/i, "partner_opportunities"],
    [/^\/admin\/partner-opportunities$/i, "admin_partner_opportunities"],
    [/^\/admin\/partner-opportunities\/regions$/i, "admin_partner_opportunity_regions"],
  ];

  for (const [pattern, name] of routes) {
    if (pattern.test(pathname)) return name;
  }

  // Fallback: normalize dynamic pieces so cardinality stays low.
  return pathname
    .toLowerCase()
    .replace(/\/[0-9]+(?=\/|$)/g, "/:id")
    .replace(/\/[0-9a-f]{8}-[0-9a-f-]{27,}(?=\/|$)/gi, "/:id")
    .replace(/^\//, "")
    .replace(/\//g, "_")
    .replace(/[^a-z0-9_:]/g, "_") || "unknown";
}

export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
    const screenName = resolveScreenName(location.pathname);
    trackScreenView(screenName);
  }, [location.pathname, location.search, location.hash]);

  return null;
}

